import * as React from 'react';
import { Link } from '../Link';
import { SubtitleLayout } from '../SubtitleLayout';
export function PhoneSmsConfirmationInfo(_ref) {
  var phone = _ref.phone,
    onEditPhoneClick = _ref.onEditPhoneClick;
  return /*#__PURE__*/React.createElement(SubtitleLayout, null, /*#__PURE__*/React.createElement("div", null, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, phone), " \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u0438\u0437 \u0441\u043C\u0441"), onEditPhoneClick && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    href: "#",
    onClick: onEditPhoneClick
  }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440")));
}